<template>
  <div class="spinner" v-if="!formData">
    <ProgressSpinner />
  </div>
  <!-- <div
    :class="{
      'version-controllers': true,
      'read-only': demo
    }"
  >
    <div class="version-controllers__change" v-if="false">
      <IndicatorDate
        name="Дата изменения"
        :mark="storyChange"
        :disabled="!validForm || formData.Id === 0"
        :date="formaterDate(formData.DateUpdated)"
        @click-icon="$emit('storyModal')"
      />
    </div>
    <div class="version-controllers__publish"  v-if="false">
      <IndicatorDate
        name="Дата добавления"
        :disabled="!validForm"
        :date="formaterDate(formData.DateCreated)"
      />
      <IndicatorDate
        name="Дата отображаемой публикации"
        calendar
        :disabled="!validForm"
        :date="formaterDate(formData.PublicationDate)"
        @change-date="changePublicationDate"
      />
      <IndicatorDate
        v-if="defferedDate"
        name="Дата отложенной публикации"
        calendar
        show-time
        :disabled="!validForm"
        :date="formData.DefferedDate"
        @change-date="changeDefferedDate"
      />
    </div>
  </div> -->

  <div class="news-constructor" v-if="formData">
    <span class="news-constructor__overlay" v-if="demo"/>
    <div
      :class="{
        'news-constructor__content content': true,
        'read-only': demo
      }"
    >
      <div class="header">
        <h2 class="header__title">Контент (текстовое наполнение и мультимедиа)</h2>
        <div class="header__line"></div>
      </div>
      <h2 class="news-constructor-title" v-if="dropdown">Направление деятельности:</h2>
      <Dropdown
        v-if="dropdown"
        v-model="formData.UniversalTagId"
        :options="formData.UniversalTags"
        option-label="Description"
        option-value="Id"
        placeholder="Направление деятельности"
        style="width: 100%; margin-bottom: 24px;"
      />
      <div class="content__directions" v-if="cascadeSelect">
        <div class="content__directions-item">
          <p class="content__directions-title">Категория товаров:</p>
          <Dropdown
            v-model="selectedParent"
            :options="parentCategories"
            option-label="Name"
            option-value="Id"
            placeholder="Выберите категорию"
            @change="onParentChange"
            style="width: 100%;"
          >
            <template #value="slotProps">
              <span v-if="slotProps.value !== null && slotProps.value !== undefined">
                <span
                  v-html="parentCategories.find(item => item.Id === slotProps.value)?.Name || ''"
                />
              </span>
              <span v-else>{{ slotProps.placeholder }}</span>
            </template>
            <template #option="slotProps">
              <span v-html="slotProps.option.Name" />
            </template>
          </Dropdown>
        </div>
        <div class="content__directions-item">
          <p class="content__directions-title">Подкатегория:</p>
          <Dropdown
            v-model="formData.UniversalTagSubChildId"
            :options="childCategories"
            option-label="Name"
            option-value="Id"
            placeholder="Выберите подкатегорию"
            :disabled="!childCategories.length"
            style="width: 100%;"
          >
            <template #value="slotProps">
              <span v-if="slotProps.value !== null && slotProps.value !== undefined">
                <span
                  v-html="childCategories.find(item => item.Id === slotProps.value)?.Name || ''"
                />
              </span>
              <span v-else>{{ slotProps.placeholder }}</span>
            </template>
            <template #option="slotProps">
              <span v-html="slotProps.option.Name" />
            </template>
          </Dropdown>
        </div>
      </div>
      <!-- <CascadeSelect
        v-if="!cascadeSelect"
        v-model="formData.UniversalTagSubChildId"
        :options="formData.UniversalTags"
        optionLabel="Name"
        optionValue="Id"
        optionGroupLabel="Name"
        style="width: 300px;"
        :optionGroupChildren="['children']"
        placeholder="Направление деятельности"
        @group-change="onChangeUniversalTag"
      /> -->
      <h2 class="news-constructor-title">
        {{ dropdown ? 'Заголовок новости (страницы):' : 'Название товара (заголовок страницы):' }}
      </h2>
      <HeaderEditorBlock
        :editor-data="formData.Header"
        @edit-data="onHeaderInput"
      />

        <BaseBtnNew
        class="news-constructor-btn"
        name="Создать URL"
        :disabled="formData?.Slug !== null && formData?.Id !== 0"
        @clickBtn="createSlug"
      >
      <urlIcon/>
      </BaseBtnNew>

        <h2 class="news-constructor-title">Url:</h2>
        <InputText
          type="text"
          v-model="formData.Slug"
          :disabled="formData?.Slug !== null && formData?.Id !== 0"
          placeholder="Заголовок"
          style="margin-bottom: 24px; height: 64px;"
          @update:modelValue="onSlugInput"
        />
      <!-- </div> -->
      <h2 class="news-constructor-title">Краткое описание:</h2>
      <HeaderEditorBlock
        :editor-data="formData.Synopsis"
        @edit-data="onSynopsisInput"
      />
      <BaseBtnNew
        style="margin-bottom: 24px;"
        name="В desccription"
        :disabled="formData?.Synopsis?.length === 0"
        @clickBtn="setSeoDescription"
      >
        <descriptionIcon/>
      </BaseBtnNew>
      <div class="news-constructor__check" v-if="checkHeader">
        <Checkbox
          v-model="formData.IsHiddenDescription"
          binary
          inputId="hideDescription"
        />
        <label for="hideDescription" class="ml-2">
          не отображать краткое описание в новости
        </label>
      </div>
        <draggable
          v-if="contentBlocks"
          v-model="formData.ContentBlocks"
          item-key="Id"
          tag="div"
          class="content__blocks"
          :animation="300"
        >
          <template #item="{ element }">
            <FormContentBlock
              :key="element.Id"
              :content-block="element"
              :blok-text="element.Text"
              :blok-type="element.Type"
              :images="element.Images"
              :video-url="element.FilePath"
              :front-image-id="formData?.FrontImageFileId"
              @on-editor-input="editorInput($event, element)"
              @click-delete="deleteContentBlock(element.Id)"
              @click-edit="$emit('edit-block', $event)"
            />
          </template>
        </draggable>

      <p class="news-constructor-title" v-if="blockAdder">Добавление контента:</p>
      <div class="constructor-adder" v-if="blockAdder">
        <BaseBtnNew
          name="Добавить текст"
          @clickBtn="addContentBlock('HyperText', true)"
        >
          <addTextIcon/>
        </BaseBtnNew>
        <BaseBtnNew
          name="Добавить фото"
          @clickBtn="addContentBlock('Image', true)"
        >
          <addPhotoIcon/>
        </BaseBtnNew>
        <BaseBtnNew
          name="Добавить видео"
          @clickBtn="addContentBlock('Video', true)"
        >
        <addVideoIcon/>
        </BaseBtnNew>
      </div>
      <slot/>
    </div>

    <div class="news-constructor__seo seo">
      <div class="header">
        <h2 class="header__title">SEO (поисковая оптимизация)</h2>
        <div class="header__line"></div>
        <CloseIcon @click="$emit('goBack')"/>
      </div>
      <div class="seo__wrapper">
        <div class="seo_item">
          <h2 class="news-constructor-title">Заголовок (SEO: Title):</h2>
          <InputText
            type="text"
            v-model="formData.SeoTitle"
            placeholder="Заголовок"
            @update:modelValue="onSeoTitleInput"
          />
        </div>
        <!-- <div class="seo__item">
          <h2 class="news-constructor-title">Теги внутренней навигации:</h2>
          <TagBox
            text-btn="Добавить новый тег"
            type-tag="inner"
            @openModal="$emit('openTagsModal')"
            :itemsArr="tags"
            :categoryId="formDataId"
          />
          <span class="news-constructor__mark">*Обязательно для заполнения</span>
        </div> -->
        <!-- <div class="seo__item">
          <h2 class="news-constructor-title">Поисковые ключевые слова (SEO: Keywords):</h2>
          <TagBox
            text-btn="Добавить ключевое слово"
            type-tag="search"
            @openModal="$emit('openKeywordsModal')"
            :itemsArr="keywords"
            :categoryId="formDataId"
          />
          <span class="news-constructor__mark">*Обязательно для заполнения
          </span>
        </div> -->
        <div class="seo__item">
          <h2 class="news-constructor-title">Поисковые ключевые слова (SEO: Keywords):</h2>
          <Textarea
            class="meta-descr"
            v-model="formData.SeoKeywords"
            rows="5"
            cols="20"
            placeholder="Ключевые слова для seo meta-keywords"
            :auto-resize="true"
            style="min-height: 220px"
            @update:modelValue="onSeoKeywordsInput"
          />
          <BaseBtnNew
            class="seo__item-btn"
            name="Очистить"
            :disabled="formData?.SeoKeywords?.length === 0"
            @clickBtn="clearSeoKeywords"
          >
          <clearIcon/>
          </BaseBtnNew>
        </div>
        <div class="seo__item">
          <h2 class="news-constructor-title">Уникальное описание (SEO: Description):</h2>
          <Textarea
            class="meta-descr"
            v-model="formData.SeoDescription"
            rows="5"
            cols="20"
            placeholder="Краткое описание для seo meta-description"
            :auto-resize="true"
            style="min-height: 290px; margin-bottom: 8px;"
            @update:modelValue="onSeoDescriptionInput"
          />
        </div>
        <!-- <div
          class="news-constructor__controllers controllers"
          v-if="!demo"
        >
          <BaseBtn
            text="Сохранить"
            :disabled="!validForm || !checkChange"
            :loader="saveBtnLoader"
            @click-btn="$emit('save-form')"
          />
          <div class="controllers__item">
            <Transition name="slide-up" class="controllers__slide">
              <BaseBtn
                v-if="!formData.Published"
                text="Опубликовать"
                :disabled="
                  !validForm
                  ||
                  !policiesValid(policies, formData.UniversalTagId)
                  ||
                  checkChange
                "
                @click-btn="$emit('toggle-publish', true)"
              />
              <BaseBtn
                v-else
                text="Снять с публикации"
                yellow
                :disabled="
                  !validForm
                  ||
                  !policiesValid(policies, formData.UniversalTagId)
                "
                @click-btn="$emit('toggle-publish', false)"
              />
            </Transition>
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <TagsModalNew
    v-if="tagsModalVisible"
  />
  <KeywordsModal
    v-if="keywordsModalVisible"
  />
</template>

<script>
import { ref, computed, watch, nextTick } from 'vue'
import { useStore } from 'vuex'
import draggable from 'vuedraggable'

import { formaterDate } from '@/helpers/helpFunctions.js'
import { sanitizeEditorHtml } from '@/helpers/unwrapEditorHtml.js'
import { policiesValid } from '@/helpers/policiesValidator'
import { v4 as uuidv4 } from 'uuid'

// import IndicatorDate from '@/components/ui/IndicatorDate.vue'
import FormContentBlock from '@/components/elements/FormContentBlock.vue'
import HeaderEditorBlock from '@/components/elements/HeaderEditorBlock.vue'
// import TagBox from '@/components/elements/TagBox.vue'
import TagsModalNew from '@/components/modals/TagsModalNew.vue'
import KeywordsModal from '@/components/modals/KeywordsModal.vue'
// import BaseBtn from '@/components/ui/BaseBtn.vue'
import BaseBtnNew from '@/components/ui/BaseBtnNew'

import Dropdown from 'primevue/dropdown'
// import CascadeSelect from 'primevue/cascadeselect'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import Checkbox from 'primevue/checkbox'
import ProgressSpinner from 'primevue/progressspinner'
import CloseIcon from '@/components/icons/CloseIcon.vue'
import clearIcon from '@/components/icons/clearIcon.vue'
import urlIcon from '@/components/icons/urlIcon.vue'
import descriptionIcon from '@/components/icons/descriptionIcon.vue'
import addPhotoIcon from '@/components/icons/addPhotoIcon'
import addVideoIcon from '@/components/icons/addVideoIcon'
import addTextIcon from '@/components/icons/addTextIcon'

export default {
  name: 'FormConstructor',
  components: {
    // IndicatorDate,
    Dropdown,
    // CascadeSelect,
    InputText,
    Textarea,
    Checkbox,
    CloseIcon,
    FormContentBlock,
    HeaderEditorBlock,
    // TagBox,
    BaseBtnNew,
    clearIcon,
    urlIcon,
    descriptionIcon,
    // BaseBtn,
    ProgressSpinner,
    draggable,
    TagsModalNew,
    KeywordsModal,
    addPhotoIcon,
    addVideoIcon,
    addTextIcon
  },
  props: {
    demo: {
      type: Boolean,
      default: false
    },
    dropdown: {
      type: Boolean,
      default: false
    },
    cascadeSelect: {
      type: Boolean,
      default: false
    },
    contentBlocks: {
      type: Boolean,
      default: false
    },
    blockAdder: {
      type: Boolean,
      default: false
    },
    storyChange: {
      type: Boolean,
      default: false
    },
    defferedDate: {
      type: Boolean,
      default: false
    },
    checkHeader: {
      type: Boolean,
      default: false
    },
    saveBtnLoader: {
      type: Boolean,
      default: false
    },
    formDataId: {
      type: Number,
      default: 0
    },
    policies: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { emit }) {
    const store = useStore()

    // объект формы
    const formData = computed(() => store.getters.getFormData)

    // const tags = computed(() => store.getters.getShowSelectedTags)

    // watch(tags, (newValue) => {
    //   formData.value.InnerTags = newValue
    // })

    const keywords = computed(() => store.getters.getShowSelectedKeywords)

    watch(keywords, (newValue) => {
      formData.value.SearchTags = newValue
    })

    const selectedParent = ref(null)
    const childCategories = ref([])

    const parentCategories = computed(() => {
      return formData.value.UniversalTags?.filter(tag => tag.Childs && tag.Childs.length > 0)
    })
    watch(
      () => formData.value,
      (newVal) => {
        if (!newVal) return

        const { UniversalTagChildId, UniversalTagSubChildId } = newVal

        // Сначала очищаем значения
        childCategories.value = []
        selectedParent.value = null

        // Если есть выбранная родительская категория
        if (UniversalTagChildId) {
          selectedParent.value = UniversalTagChildId

          // Находим родительскую категорию по ID
          const parentTag = formData.value.UniversalTags.find(tag => tag.Id === UniversalTagChildId)

          if (parentTag) {
            childCategories.value = parentTag.Childs || []
          }
        }

        // Устанавливаем подкатегорию
        if (UniversalTagSubChildId) {
          formData.value.UniversalTagSubChildId = UniversalTagSubChildId
        }
      },
      { immediate: true, deep: true }
    )

    const onParentChange = () => {
      if (selectedParent.value) {
        const parent = formData.value.UniversalTags.find(t => t.Id === selectedParent.value)
        childCategories.value = parent?.Childs || []
        formData.value.UniversalTagId = null
        formData.value.UniversalTagChildId = selectedParent.value
        formData.value.UniversalTagId = parent?.ParentTagId
      } else {
        childCategories.value = []
        formData.value.UniversalTagId = null
      }
    }

    nextTick(() => {
      // Принудительно "перерисовать" модель
      const currentValue = formData.value.UniversalTagSubChildId
      formData.value.UniversalTagSubChildId = null
      nextTick(() => {
        formData.value.UniversalTagSubChildId = currentValue
      })
    })

    // Авто-восстановление при редактировании существующей записи
    watch(() => formData.value.UniversalTagId, (newVal) => {
      if (newVal) {
        const child = formData.value.UniversalTags.flatMap(t => t.Childs).find(c => c.Id === newVal)
        if (child) {
          selectedParent.value = child.ParentTagId
          onParentChange()
        }
      }
    })

    // Очистка при обновлении данных
    watch(() => formData.value.UniversalTags, () => {
      childCategories.value = []
      selectedParent.value = null
    })

    // Функция для замены кавычек в простом тексте (не HTML)
    const replaceQuotesInText = (text) => {
      if (!text || typeof text !== 'string') return text

      // Заменяем двойные кавычки
      let result = text.replace(/"([^"]+)"/g, '«$1»')

      // Заменяем HTML entities
      result = result.replace(/&quot;([^&]+)&quot;/g, '«$1»')

      // Заменяем одиночные кавычки в определенных контекстах
      result = result.replace(/(\s|^|\(|\[|{)'([^']+)'/g, '$1«$2»')

      return result
    }

    // Обработчики для полей ввода
    const onHeaderInput = (value) => {
      formData.value.Header = sanitizeEditorHtml(value)
    }

    const onSynopsisInput = (value) => {
      formData.value.Synopsis = sanitizeEditorHtml(value)
    }

    const onSeoTitleInput = (value) => {
      const processedValue = replaceQuotesInText(value)
      if (value !== processedValue) {
        formData.value.SeoTitle = processedValue
      }
    }

    const onSeoKeywordsInput = (value) => {
      const processedValue = replaceQuotesInText(value)
      if (value !== processedValue) {
        formData.value.SeoKeywords = processedValue
      }
    }

    const onSeoDescriptionInput = (value) => {
      const processedValue = replaceQuotesInText(value)
      if (value !== processedValue) {
        formData.value.SeoDescription = processedValue
      }
    }

    const onSlugInput = (value) => {
      if (typeof value !== 'string') return

      const processedValue = value.replace(/\s+/g, '-')
      if (value !== processedValue) {
        formData.value.Slug = processedValue
      }
    }

    // глубокая копия объекта формы чтобы отcлеживать изменения
    const originFormData = computed(() => store.getters.getOriginFormData)

    // отслеживает изменения объекта формы
    const checkChange = computed(() => {
      return JSON.stringify(formData.value) !== JSON.stringify(originFormData.value)
    })

    // определяет есть ли незаполненные поля из обязательных
    const validForm = computed(() => {
      switch (true) {
        case formData.value.UniversalTagId === 0 :
        case formData.value.Header === null :
        case formData.value.Header?.trim() === '' :
        case formData.value.Synopsis === null:
        case formData.value.Synopsis?.trim() === '':
          return false
        default:
          return true
      }
    })

    // добавить контент блок в новость
    const addContentBlock = (type) => {
      const obj = {
        Configuration: null,
        FilePath: '',
        Images: [],
        Modificator: null,
        Text: '',
        Type: type,
        Id: Number(uuidv4().replace(/\D/g, '').slice(0, 5))
      }

      switch (type) {
        case 'HyperText':
          store.commit('SetContentBlock', obj)
          store.commit('SetAddContentBlock')
          break
        case 'Image':
          store.commit('SetContentBlock', obj)
          emit('modalSwitch', 'Image', true)
          break
        case 'Video':
          store.commit('SetContentBlock', obj)
          emit('modalSwitch', 'Video', true)
          break
      }
    }

    // удалить контент блок
    const deleteContentBlock = (val) => {
      formData.value.ContentBlocks = formData.value.ContentBlocks.filter((item) => {
        return item.Id !== val
      })
    }

    // получает текст из CKEditor (редактор текста)
    // и сохраняет в соответвтующий контекст блок
    const editorInput = (event, item) => {
      item.Text = sanitizeEditorHtml(event)
    }

    // изменить дату публикации
    const changePublicationDate = (e) => {
      // возможно следует переделать чтобы при clear
      // устанавливалась текущая дата
      formData.value.PublicationDate = e
    }

    // отложенная публикация а также её отмена
    const changeDefferedDate = (e) => {
      console.log('e: ', e)

      formData.value.DefferedDate = e
      // эту логику надо переработать чтобы запрос срабатывал при нажатии кнопки "сохранить"
      // const obj = {
      //   value: e
      // }

      // if (type === 'select') {
      //   formData.value.DefferedDate = e

      //   store.commit('SetFormData', { ...formData.value })

      //   store.dispatch('setDefferedDate', obj)
      // } else if (type === 'clear') {
      //   obj.value = null
      //   formData.value.DefferedDate = null
      //   store.commit('SetFormData', { ...formData.value })
      //   store.dispatch('setDefferedDate', obj)
      // }
    }

    const onChangeUniversalTag = (e) => {
      // при клике на группу проставляет UniversalTagId
      if (e.value.ParentTagId !== null) {
        formData.value.UniversalTagId = e.value.ParentTagId
        formData.value.UniversalTagChildId = e.value.Id
      }
    }

    const tagsModalVisible = computed(() => {
      return store.getters.getShowTagsEditor
    })

    const keywordsModalVisible = computed(() => {
      return store.getters.getShowKeywordsEditor
    })

    const clearSeoKeywords = () => {
      formData.value.SeoKeywords = ''
    }

    watch([validForm, checkChange], () => {
      emit('update-validity', {
        valid: validForm.value,
        changed: checkChange.value,
        canSave: validForm.value && checkChange.value
      })
    }, { immediate: true })

    const canPublish = computed(() => {
      return (
        validForm.value &&
    !checkChange.value && // только если всё сохранено
    policiesValid(props?.policies, formData.value.UniversalTagId)
      )
    })

    watch(canPublish, () => {
      emit('update-publish-status', {
        canPublish: canPublish.value,
        isValid: validForm.value,
        isClean: !checkChange.value,
        policyPassed: policiesValid(props?.policies, formData.value.UniversalTagId)
      })
    }, { immediate: true })

    const createSlug = () => {
      formData.value.Slug = slugify(formData.value.Header)
    }

    const slugify = (text) => {
      if (!text) return ''
      return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/[а-яё]/g, (char) => {
          const map = {
            а: 'a',
            б: 'b',
            в: 'v',
            г: 'g',
            д: 'd',
            е: 'e',
            ё: 'yo',
            ж: 'zh',
            з: 'z',
            и: 'i',
            й: 'y',
            к: 'k',
            л: 'l',
            м: 'm',
            н: 'n',
            о: 'o',
            п: 'p',
            р: 'r',
            с: 's',
            т: 't',
            у: 'u',
            ф: 'f',
            х: 'h',
            ц: 'ts',
            ч: 'ch',
            ш: 'sh',
            щ: 'shch',
            ъ: '',
            ы: 'y',
            ь: '',
            э: 'e',
            ю: 'yu',
            я: 'ya'
          }
          return map[char] || char
        })
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '')
    }

    const setSeoDescription = () => {
      formData.value.SeoDescription = formData.value.Synopsis
    }

    return {
      formData,
      checkChange,
      policiesValid,
      addContentBlock,
      editorInput,
      deleteContentBlock,
      changePublicationDate,
      changeDefferedDate,
      validForm,
      formaterDate,
      onChangeUniversalTag,
      tagsModalVisible,
      keywordsModalVisible,
      // tags,
      keywords,
      selectedParent,
      parentCategories,
      childCategories,
      onParentChange,
      clearSeoKeywords,
      createSlug,
      setSeoDescription,
      onHeaderInput,
      onSynopsisInput,
      onSeoTitleInput,
      onSeoKeywordsInput,
      onSeoDescriptionInput,
      onSlugInput
    }
  }
}
</script>
<style>
.news-constructor .p-dropdown .p-inputtext {
  border: none;
  display: flex;
  align-items: center;
}

.p-dropdown-panel .p-dropdown-items {
  padding: 0.5rem 0;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  color: #495057;
  background: #E3F2FD;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  margin: 0;
  padding: 0.5rem 1rem;
  border: 0 none;
  color: #495057;
  background: transparent;
  transition: box-shadow 0.2s;
  border-radius: 0;
}

</style>

<style lang="scss" scoped>
.spinner {
  @include flex-center;
}
.p-dropdown {
  border: 1px solid #ced4da !important;
  padding: 10px 12px;
}

.seo_item {
  .p-inputtext {
    width: 100%;
    margin-bottom: 24px;
  }
}
.read-only {
  pointer-events: none;
}
.meta-descr {
  width: 100%;
  height: 120px !important;
  overflow: auto !important;
  background: #FFFFFF;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}
.news-constructor {
  position: relative;
  display: flex;
  align-items: start;
  justify-content: space-between;
  padding-right: 10px;
  overflow-y: auto;

  &-btn {
    margin-bottom: 8px;
  }

    /* Стили для скролла */
  &::-webkit-scrollbar {
    width: 4px; /* ширина для горизонтального скролла */
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #00ABEC;

    &:hover {
      background-color: rgb(27, 166, 218);
    }
  }

  &__mark {
    margin-bottom: 18px;
    text-align: start;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: -0.02em;
    font-feature-settings: 'calt' off;
    color: #848484;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    text-align: left;
    margin-bottom: 8px;
  }

  &__check {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    width: 49%;
    background-color: #FFFFFF;
  }

  &__controllers, .controllers {
    display: flex;
    justify-content: center;
    gap: 15px;

    &__item {
      position: relative;
      width: 218px;
    }

    &__slide {
      position: absolute;
      inset: 0;
    }
  }
}

.seo {
  height: calc(100vh - 115px);
  padding-bottom: 10px;
  overflow: auto;
  position: sticky;
  top: 0;
  width: 49%;
  border-left: 2px solid #C8C8C8;
  padding-left: 24px;

  &__item {
    margin-bottom: 24px;

    &-btn {
      margin-top: 8px;
    }
  }
}
.header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;

  &__line {
    display: block;
    flex: 1;
    height: 2px;
    background-color: #C8C8C8;
  }

  &__title {
    font-size: 18px;
    font-weight: 700;
  }
}

.content {
  padding-bottom: 10px;
  height: calc(100vh - 115px);
  overflow: auto;
  padding-right: 10px;
  &__directions {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: flex-start;
    margin-bottom: 24px;

    &-item {
      width: 100%;
      text-align: left;
    }
    &-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 1.8;
    }
  }
}

.constructor-adder {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 24px;
}
::-webkit-scrollbar {
  width: 4px; /* ширина для горизонтального скролла */
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #00ABEC;

  &:hover {
    background-color: rgb(27, 166, 218);
  }
}
// анимация кнопки публикации и снятия с публикации
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.25s ease-out;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

:deep(.p-dropdown:hover) {
  border-color: #00ABEC !important;
}
.p-dropdown {
  background-color: #F5F5F5;
  border: 1px solid #C8C8C8;
  border-radius: 6px;
  text-align: left;

  height: 42px;
  padding: 5px;
}
.p-disabled {
  opacity: 0.5;
}
:deep(.p-dropdown) {
  &.p-focus {
    box-shadow: none !important;
    outline: none; /* опционально: убрать outline, если тоже мешает */
  }

  &:focus-visible {
    box-shadow: none !important;
    outline: none;
  }
}
:deep(.base-button) {
  width: 200px;
}
:deep(.footer) {
  justify-content: flex-end !important;
}
.p-inputwrapper-filled {
  //color: #000000 !important;
  &:hover {
    //background-color: #0080B1 !important;
    //color: #FFFFFF !important;
    //fill: #FFFFFF !important;
  }
}
:deep(.p-dropdown) {
  &.p-inputwrapper-filled {
    .p-dropdown-clear-icon,
    .p-dropdown-trigger,
    .p-dropdown-label,
    .p-dropdown-item .p-checkbox .p-checkbox-box,
    .p-dropdown-item .p-checkbox .p-checkbox-icon {
      &:hover {
        //color: #FFFFFF !important;
      }
    }
  }
}

:deep(.p-inputtext) {
  border: 1px solid #000000;
  // -webkit-box-shadow: inset 0 0 0 50px white;
}

:deep(.p-inputtext:enabled:hover) {
  border-color: #00ABEC;
}
:deep(.p-inputtext:disabled) {
  opacity: 0.5;
}

:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.1rem #00ABEC;
  border-color: #00ABEC;
  -webkit-box-shadow: inset 0 0 0 50px white;
}
</style>
